<mat-form-field>
  <mat-chip-grid #chipList>
    @for (option of selectedOptions; track option) {
      <mat-chip-row [removable]="true" (removed)="removeOption(option)">
        {{ displayProperty && option ? option[displayProperty] : option}}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip-row>
    }
    <input matInput #optionInput [formControl]="optionCtrl" placeholder="{{placeholder}}" [matAutocomplete]="autoP"
      [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="addOption($event)">
  </mat-chip-grid>
  <mat-autocomplete #autoP="matAutocomplete" (optionSelected)="selectedOption($event)">
    @for (option of filteredOptions | async; track option) {
      <mat-option
        [value]="valueProperty ? option[valueProperty]: option">
        {{ displayProperty && option? option[displayProperty] : option }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>